import React, { useEffect, useRef, useState } from "react";
import { baseUrl, config } from "../../../services/config";
import { Paper } from "@material-ui/core";
import { Modal, Spinner, Table } from "react-bootstrap";
import { useAlert } from "react-alert";
import ReactToPrint from "react-to-print";
import { upperCase } from "lodash";
import { DatePicker } from "antd";
import { DownloadTableExcel } from "react-export-table-to-excel";
import "./FirmWiseReport.css";
const { RangePicker } = DatePicker;
const pageStyle = `
  @page {
      margin-left: 0.5in;
    size: A4 portrate !important;
}
`;

const FirmWiseReport = () => {
  const [yearId, setYearId] = useState("");
  const [values, setValues] = useState("");
  const [buttonDisable, setbuttonDisable] = useState(false);
  const [sessionData, setSessionData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sessionName, setSessionName] = useState("");
  const [firmName, setFirmName] = useState("");
  const [banks, setallbanks] = useState([]);
  const [viewModal, setViewModal] = useState(false);
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [isVisible, setIsVisible] = useState(false);
  //for print
  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  const componentRef = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);
  let authtoken = localStorage.getItem("userToken");
  const alert = useAlert();

  const [startDate, setStartDate] = useState("");
  const [endDate, setendDate] = useState("");

  const [reportData, setReportData] = useState([]);
  const [selectedItem, setSelectedItem] = useState([]);
  const [debitSum, setDebitSum] = useState(0);
  const [creditSum, setCreditSum] = useState(0);
  const [lossDebited, setLossDebited] = useState(0);
  const [profitCredited, setProfitCredited] = useState(0);

  const tableRef = useRef(null);

  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);

  const [oldTrailBalance, setOldTrailBalance] = useState(false);
  useEffect(() => {
    getSettingData();
    sessions();
    getAllBanks();
  }, []);

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  function handleInput(event) {
    setValues(event.target.value);
    setFirmName(event.target.selectedOptions[0].text);
    console.log(values);
  }
  const getAllBanks = async () => {
    fetch(`${baseUrl}/bank_account_category`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallbanks(data.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const sessions = () => {
    fetch(`${baseUrl}/session`, {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setSessionData(data.payload);
        data.payload.forEach((session, index) => {
          if (session.active_financial_year == "1") {
            setYearId(session.id);
            setSessionName(session.year);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const datePicker = (value, dateString) => {
    console.log("Formatted Selected Time: ", dateString);
    setStartDate(dateString[0]);
    setendDate(dateString[1]);
  };

  const handleGetData = () => {
    if (yearId == "") {
      alert.error("Please select the year");
      return;
    }

    if (values == "") {
      alert.error("Please select the firm");
      return;
    }

    if (values === "1") {
      alert.error("Cash firm is not correct firm");
      return;
    }
    setLoading(true);
    setbuttonDisable(true);
    const data = {
      year_id: yearId,
      start_date: startDate,
      end_date: endDate,
      bank_id: values,
    };
    fetch(`${baseUrl}/firmview`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.metadata.success) {
          setLoading(false);
          setbuttonDisable(false);
          alert.error(data.metadata.message);
          return;
        } else {
          setLoading(false);
          setbuttonDisable(false);
          setIsVisible(true);

          setReportData(data.payload.details);
          setCreditSum(data.payload.conclusion?.grand_total_credit);
          setDebitSum(data.payload.conclusion?.grand_total_debit);
          setLossDebited(data.payload.conclusion?.loss_debited);
          setProfitCredited(data.payload.conclusion?.profit_credited);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("err is re", err);
      });
  };
  //for print
  const handleBeforePrint = React.useCallback(() => {
    console.log("`onBeforePrint` called");
  }, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    console.log("`onBeforeGetContent` called");
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called");
  }, []);

  const parseAmount = (amount) => {
    const number = Number(String(amount || 0).replace(/,/g, ""));
    return Number.isNaN(number) ? 0 : number;
  };

  const formatBalance = (balance) => {
    if (balance > 0) {
      return Intl.NumberFormat("en-Us").format(balance) + " DR";
    } else if (balance < 0) {
      return Intl.NumberFormat("en-Us").format(Math.abs(balance)) + " CR";
    } else {
      return Intl.NumberFormat("en-Us").format(0);
    }
  };

  const getLedgersWithBalance = (ledgers = []) => {
    let balance = 0;

    return ledgers.map((item) => {
      balance += parseAmount(item.debit) - parseAmount(item.credit);

      return {
        ...item,
        balance: balance,
      };
    });
  };

  const addBalancesToHierarchy = (data = []) =>
    data.map((base) => {
      const accountGroup = (base.account_group || []).map((item) => {
        const accountChart = (item.account_chart || []).map((subitem) => {
          const subAccount = (subitem.sub_account || []).map((last) => {
            const ledgers = getLedgersWithBalance(last.general_ledgers);

            return {
              ...last,
              opening_balance: ledgers.length > 0 ? ledgers[0].balance : 0,
              balance:
                ledgers.length > 0 ? ledgers[ledgers.length - 1].balance : 0,
            };
          });

          return {
            ...subitem,
            sub_account: subAccount,
            opening_balance: subAccount.reduce(
              (total, item) => total + item.opening_balance,
              0,
            ),
            balance: subAccount.reduce(
              (total, item) => total + item.balance,
              0,
            ),
          };
        });

        return {
          ...item,
          account_chart: accountChart,
          opening_balance: accountChart.reduce(
            (total, subitem) => total + subitem.opening_balance,
            0,
          ),
          balance: accountChart.reduce(
            (total, subitem) => total + subitem.balance,
            0,
          ),
        };
      });

      return {
        ...base,
        account_group: accountGroup,
        opening_balance: accountGroup.reduce(
          (total, item) => total + item.opening_balance,
          0,
        ),
        balance: accountGroup.reduce((total, item) => total + item.balance, 0),
      };
    });

  const firmBalanceData = addBalancesToHierarchy(reportData);
  const firmBalanceTotals = firmBalanceData.reduce(
    (totals, base) => ({
      opening_balance: totals.opening_balance + base.opening_balance,
      balance: totals.balance + base.balance,
    }),
    { opening_balance: 0, balance: 0 },
  );

  const hasSubAccountBalance = (subAccount) =>
    Number(subAccount?.credit ?? 0) > 0 ||
    Number(subAccount?.debit ?? 0) > 0 ||
    Number(subAccount?.cr ?? 0) > 0 ||
    Number(subAccount?.dr ?? 0) > 0;

  const hasChartBalance = (chart) =>
    Number(chart?.account_chart_credit ?? 0) > 0 ||
    Number(chart?.account_chart_debit ?? 0) > 0 ||
    chart?.sub_account?.some(hasSubAccountBalance);

  const hasGroupBalance = (group) =>
    Number(group?.account_group_credit ?? 0) > 0 ||
    Number(group?.account_group_debit ?? 0) > 0 ||
    group?.account_chart?.some(hasChartBalance);

  const hasBaseBalance = (base) =>
    Number(base?.base_account_credit ?? 0) > 0 ||
    Number(base?.base_account_debit ?? 0) > 0 ||
    base?.account_group?.some(hasGroupBalance);

  const getSubAccountDebit = (subAccount) =>
    !oldTrailBalance ? Number(subAccount.dr) : Number(subAccount.debit);

  const getSubAccountCredit = (subAccount) =>
    !oldTrailBalance ? Number(subAccount.cr) : Number(subAccount.credit);

  return (
    <>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div className="row align-items-end">
          <div className="col-xl-3 col-sm-6 col-12 mb-4">
            <label className="form-label">
              <b>Select Session</b>
            </label>
            <div className="d-flex flex-column">
              <select
                style={{ height: 40 }}
                className="form-select"
                name="year_id"
                value={yearId}
                aria-label="Default select example"
                onChange={(e) => {
                  const data = sessionData.find((ses) => {
                    return ses.id == e.target.value;
                  });
                  console.log(data);
                  setSessionName(data.year);
                  setYearId(e.target.value);
                }}
              >
                <option value="">Select Session</option>
                {sessionData &&
                  sessionData.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.year}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          <div className="col-xl-3 col-sm-6 col-12 mb-4">
            <label className="form-label">
              <b>Select Firm</b>
            </label>
            <div className="d-flex flex-column">
              <select
                className="form-control form-select"
                onChange={(e) => {
                  handleInput(e);
                }}
                name="bank2"
                id="bank2"
                required
              >
                <option value="">Select Firm</option>
                {banks.map((campus) => (
                  <option
                    key={campus.id}
                    disabled={campus.id === 1}
                    value={campus.id}
                  >
                    {campus.title}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 col-12 mb-4">
            <label className="form-label d-block">
              <b>Select Start & End Date</b>
            </label>
            <RangePicker
              getPopupContainer={(triggerNode) => {
                return triggerNode.parentNode;
              }}
              style={{ height: 40, width: "100%" }}
              onChange={datePicker}
            />
          </div>
          <div className="col-xl-3 col-sm-6 col-12 mb-4">
            <div className="firm-wise-report-actions">
              <button
                className="btn btn-primary"
                disabled={buttonDisable}
                onClick={handleGetData}
              >
                Show
              </button>

              {reportData?.length > 0 ? (
                <>
                  <ReactToPrint
                    documentTitle={`Firm Wise Report`}
                    onAfterPrint={handleAfterPrint}
                    onBeforeGetContent={handleOnBeforeGetContent}
                    onBeforePrint={handleBeforePrint}
                    removeAfterPrint={true}
                    pageStyle={pageStyle}
                    trigger={() => (
                      <button
                        // onClick={() => console.log("dfsdfsdfd")}
                        disabled={printloading ? true : false}
                        className="btn btn-primary w-105px"
                      >
                        {printloading ? <span>Printing..</span> : "Print"}
                      </button>
                    )}
                    content={() => componentRef.current}
                  />

                  <DownloadTableExcel
                    filename="Firm Wise Report"
                    sheet="Firm Wise Report"
                    currentTableRef={tableRef.current}
                  >
                    <button className="btn btn-primary">Export</button>
                  </DownloadTableExcel>
                </>
              ) : null}
            </div>
          </div>
          {reportData?.length > 0 ? (
            <div className="col-12 mb-4">
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  onChange={(e) => setOldTrailBalance(e.target.checked)}
                />
                <span />
                &nbsp;&nbsp;&nbsp; Show Simple Firm Wise Report
              </label>
            </div>
          ) : null}
        </div>

        <div className="mt-5">
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Spinner class="text-center" variant="info" animation="border" />
            </div>
          ) : isVisible ? (
            <div id="tableboot mt-4">
              <div className="d-flex">
                <div>
                  <img
                    style={{ height: 100, width: 110 }}
                    src={icon}
                    alt="logo"
                  />
                </div>
                <div className="mx-5" style={{ paddingTop: "10px" }}>
                  <h1>{unitName}</h1>
                  <h3>
                    Firm Wise Report For The Financial Year {sessionName} Till
                    Date {date}
                  </h3>
                  <h4>Firm Name: {firmName}</h4>
                </div>
              </div>
              {/* <Table className="mt-4" responsive>
                <thead>
                  <tr id="tbl">
                    <th className="text-center">A/C Code</th>
                    <th className="text-center">Account Name</th>
                    <th className="text-center">Debit</th>
                    <th className="text-center">Credit</th>
                  </tr>
                </thead>

                <tbody>
                  {reportData.map((base) =>
                    base.account_group.length > 0 ? (
                      <React.Fragment key={base.base_account}>
                        <tr id="tbl">
                          <th
                            colSpan={2}
                            className="text-center text-color-primary"
                            style={{ fontSize: "1.1rem" }}
                          >
                            {base?.base_account}
                          </th>
                          <th
                            className="text-center text-color-primary"
                            style={{ fontSize: "1.1rem" }}
                          >
                            {Intl.NumberFormat("en-Us").format(
                              base?.base_account_debit,
                            )}
                          </th>
                          <th
                            className="text-center text-color-primary"
                            style={{ fontSize: "1.1rem" }}
                          >
                            {Intl.NumberFormat("en-Us").format(
                              base?.base_account_credit,
                            )}
                          </th>
                        </tr>
                        {base.account_group.map((item) =>
                          item.account_group.length > 0 ? (
                            <React.Fragment key={item.account_group_code}>
                              <tr id="tbl">
                                <td
                                  style={{
                                    color: "#fd12b3",
                                    fontWeight: "bold",
                                  }}
                                  className="text-start pl-10"
                                >
                                  {item?.account_group_code}
                                </td>
                                <td
                                  style={{
                                    color: "#fd12b3",
                                    fontWeight: "bold",
                                  }}
                                  className="text-start"
                                >
                                  {item?.account_group}
                                </td>
                                <td
                                  style={{
                                    fontWeight: "bold",
                                  }}
                                  className="text-center text-color-primary"
                                >
                                  {Intl.NumberFormat("en-Us").format(
                                    item?.account_group_debit,
                                  )}
                                </td>
                                <td
                                  style={{
                                    fontWeight: "bold",
                                  }}
                                  className="text-center text-color-primary"
                                >
                                  {Intl.NumberFormat("en-Us").format(
                                    item?.account_group_credit,
                                  )}
                                </td>
                              </tr>
                              {item.account_chart.map((subitem) =>
                                subitem.sub_account.length > 0 ? (
                                  <React.Fragment
                                    key={subitem.account_chart_code}
                                  >
                                    <tr id="tbl">
                                      <td
                                        style={{
                                          color: "black",
                                          paddingLeft: "30px",
                                          fontWeight: "bold",
                                        }}
                                        className="text-center"
                                      >
                                        {subitem.account_chart_code}
                                      </td>
                                      <td
                                        style={{
                                          color: "black",
                                          paddingLeft: "30px",
                                          fontWeight: "bold",
                                        }}
                                        className="text-start"
                                      >
                                        {subitem.account_chart}
                                      </td>

                                      <td
                                        style={{ color: "black" }}
                                        className="text-center"
                                      ></td>
                                    </tr>
                                    {subitem.sub_account.length > 0
                                      ? subitem.sub_account.map((last) => (
                                          <React.Fragment
                                            key={last.sub_account_code}
                                          >
                                            <tr id="tbl">
                                              <td
                                                style={{
                                                  color: "black",
                                                  paddingLeft: "60px",
                                                }}
                                                className="text-end"
                                              >
                                                {last.sub_account_code}
                                              </td>
                                              <td
                                                style={{
                                                  color: "black",
                                                  paddingLeft: "60px",
                                                  cursor: "pointer",
                                                }}
                                                className="text-start"
                                                onClick={() => {
                                                  setSelectedItem(last);
                                                  setViewModal(true);
                                                }}
                                              >
                                                {last.sub_account}
                                              </td>

                                              <td
                                                style={{ color: "black" }}
                                                className="text-center"
                                              >
                                                {Intl.NumberFormat(
                                                  "en-Us",
                                                ).format(last.debit)}
                                              </td>
                                              <td
                                                style={{ color: "black" }}
                                                className="text-center"
                                              >
                                                {Intl.NumberFormat(
                                                  "en-Us",
                                                ).format(last.credit)}
                                              </td>
                                            </tr>
                                          </React.Fragment>
                                        ))
                                      : null}
                                    <tr id="tbl">
                                      <td
                                        style={{
                                          color: "black",
                                          paddingLeft: "30px",
                                        }}
                                        className="text-start"
                                      ></td>
                                      <td
                                        style={{
                                          color: "black",
                                          fontWeight: "bold",
                                        }}
                                        className="text-end pr-10"
                                      >
                                        Control Accounts Total :-
                                      </td>

                                      <td
                                        style={{
                                          color: "black",
                                          fontWeight: "bold",
                                          borderTop: "2px solid black",
                                          borderBottom: "2px solid black",
                                        }}
                                        className="text-center"
                                      >
                                        {Intl.NumberFormat("en-Us").format(
                                          subitem?.account_chart_debit,
                                        )}
                                      </td>

                                      <td
                                        style={{
                                          color: "black",
                                          fontWeight: "bold",
                                          borderTop: "2px solid black",
                                          borderBottom: "2px solid black",
                                        }}
                                        className="text-center"
                                      >
                                        {Intl.NumberFormat("en-Us").format(
                                          subitem?.account_chart_credit,
                                        )}
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                ) : null,
                              )}
                            </React.Fragment>
                          ) : null,
                        )}
                      </React.Fragment>
                    ) : null,
                  )}

                  <tr id="tbl">
                    <td
                      style={{ color: "black", paddingLeft: "30px" }}
                      className="text-start"
                    ></td>
                    <td
                      style={{
                        fontSize: "1.3rem",
                        paddingRight: "50px",
                        fontWeight: "bold",
                      }}
                      className="text-end text-color-primary"
                    >
                      {lossDebited != 0
                        ? "Loss Debited :-"
                        : "Profit Credited :-"}
                    </td>

                    <td
                      style={{
                        fontSize: "1.3rem",
                        fontWeight: "bold",
                        borderTop: "2px solid black",
                        borderBottom: "2px solid black",
                      }}
                      className="text-center text-color-primary"
                    >
                      {lossDebited != 0
                        ? Intl.NumberFormat("en-Us").format(lossDebited)
                        : 0}
                    </td>

                    <td
                      style={{
                        fontSize: "1.3rem",
                        fontWeight: "bold",
                        borderTop: "2px solid black",
                        borderBottom: "2px solid black",
                      }}
                      className="text-center text-color-primary"
                    >
                      {profitCredited != 0
                        ? Intl.NumberFormat("en-Us").format(profitCredited)
                        : 0}
                    </td>
                  </tr>

                  <tr id="tbl">
                    <td
                      style={{ color: "black", paddingLeft: "30px" }}
                      className="text-start"
                    ></td>
                    <td
                      style={{
                        fontSize: "1.3rem",
                        paddingRight: "50px",
                        fontWeight: "bold",
                      }}
                      className="text-end text-color-primary"
                    >
                      Grand Total :-
                    </td>

                    <td
                      style={{
                        fontSize: "1.3rem",
                        fontWeight: "bold",
                        borderTop: "2px solid black",
                        borderBottom: "2px solid black",
                      }}
                      className="text-center text-color-primary"
                    >
                      {Intl.NumberFormat("en-Us").format(debitSum)}
                    </td>

                    <td
                      style={{
                        fontSize: "1.3rem",
                        fontWeight: "bold",
                        borderTop: "2px solid black",
                        borderBottom: "2px solid black",
                      }}
                      className="text-center text-color-primary"
                    >
                      {Intl.NumberFormat("en-Us").format(creditSum)}
                    </td>
                  </tr>
                </tbody>
              </Table> */}
              <Table className="mt-4" responsive>
                <thead>
                  <tr id="tbl">
                    <th className="text-center">A/C Code</th>
                    <th className="text-center">Account Name</th>
                    {!oldTrailBalance && (
                      <th className="text-center">Opening Bal.</th>
                    )}
                    <th className="text-center">Debit</th>
                    <th className="text-center">Credit</th>
                    {!oldTrailBalance && (
                      <th className="text-center">Balance</th>
                    )}
                  </tr>
                </thead>

                <tbody>
                  {firmBalanceData?.filter(hasBaseBalance)?.map((base) => (
                    <React.Fragment key={base.base_account}>
                      <tr id="tbl">
                        <th
                          colSpan={2}
                          className="text-center text-color-primary"
                          style={{ fontSize: "1.1rem" }}
                        >
                          {base?.base_account}
                        </th>
                        {!oldTrailBalance && (
                          <th
                            className="text-center text-color-primary"
                            style={{ fontSize: "1.1rem" }}
                          >
                            {formatBalance(base.opening_balance)}
                          </th>
                        )}
                        <th
                          className="text-center text-color-primary"
                          style={{ fontSize: "1.1rem" }}
                        >
                          {Intl.NumberFormat("en-Us").format(
                            base?.base_account_debit,
                          )}
                        </th>
                        <th
                          className="text-center text-color-primary"
                          style={{ fontSize: "1.1rem" }}
                        >
                          {Intl.NumberFormat("en-Us").format(
                            base?.base_account_credit,
                          )}
                        </th>
                        {!oldTrailBalance && (
                          <th
                            className="text-center text-color-primary"
                            style={{ fontSize: "1.1rem" }}
                          >
                            {formatBalance(base.balance)}
                          </th>
                        )}
                      </tr>
                      {base.account_group
                        ?.filter(hasGroupBalance)
                        ?.map((item) => (
                          <React.Fragment key={item.account_group_code}>
                            <tr id="tbl">
                              <td
                                style={{
                                  color: "#fd12b3",
                                  fontWeight: "bold",
                                }}
                                className="text-start pl-10"
                              >
                                {item?.account_group_code}
                              </td>
                              <td
                                style={{
                                  color: "#fd12b3",
                                  fontWeight: "bold",
                                }}
                                className="text-start"
                              >
                                {item?.account_group}
                              </td>
                              {!oldTrailBalance && (
                                <td
                                  style={{
                                    fontWeight: "bold",
                                  }}
                                  className="text-center text-color-primary"
                                >
                                  {formatBalance(item.opening_balance)}
                                </td>
                              )}
                              <td
                                style={{
                                  fontWeight: "bold",
                                }}
                                className="text-center text-color-primary"
                              >
                                {Intl.NumberFormat("en-Us").format(
                                  item?.account_group_debit,
                                )}
                              </td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                }}
                                className="text-center text-color-primary"
                              >
                                {Intl.NumberFormat("en-Us").format(
                                  item?.account_group_credit,
                                )}
                              </td>
                              {!oldTrailBalance && (
                                <td
                                  style={{
                                    fontWeight: "bold",
                                  }}
                                  className="text-center text-color-primary"
                                >
                                  {formatBalance(item.balance)}
                                </td>
                              )}
                            </tr>
                            {item.account_chart
                              ?.filter(hasChartBalance)
                              ?.map((subitem) => (
                                <React.Fragment
                                  key={subitem.account_chart_code}
                                >
                                  <tr id="tbl">
                                    <td
                                      style={{
                                        color: "black",
                                        paddingLeft: "30px",
                                        fontWeight: "bold",
                                      }}
                                      className="text-center"
                                    >
                                      {subitem.account_chart_code}
                                    </td>
                                    <td
                                      style={{
                                        color: "black",
                                        paddingLeft: "30px",
                                        fontWeight: "bold",
                                      }}
                                      className="text-start"
                                    >
                                      {subitem.account_chart}
                                    </td>
                                    {!oldTrailBalance && (
                                      <td
                                        style={{ color: "black" }}
                                        className="text-center"
                                      ></td>
                                    )}
                                    <td
                                      style={{ color: "black" }}
                                      className="text-center"
                                    ></td>
                                    <td
                                      style={{ color: "black" }}
                                      className="text-center"
                                    ></td>
                                    {!oldTrailBalance && (
                                      <td
                                        style={{ color: "black" }}
                                        className="text-center"
                                      ></td>
                                    )}
                                  </tr>
                                  {subitem.sub_account
                                    ?.filter(hasSubAccountBalance)
                                    .map((last) => (
                                      <React.Fragment
                                        key={last.sub_account_code}
                                      >
                                        <tr id="tbl">
                                          <td
                                            style={{
                                              color: "black",
                                              paddingLeft: "60px",
                                            }}
                                            className="text-end"
                                          >
                                            {last.sub_account_code}
                                          </td>
                                          <td
                                            style={{
                                              color: "black",
                                              paddingLeft: "60px",
                                              cursor: "pointer",
                                            }}
                                            className="text-start"
                                            onClick={() => {
                                              setSelectedItem(last);
                                              setViewModal(true);
                                            }}
                                          >
                                            {last.sub_account}
                                          </td>
                                          {!oldTrailBalance && (
                                            <td
                                              style={{ color: "black" }}
                                              className="text-center"
                                            >
                                              {formatBalance(
                                                last.opening_balance,
                                              )}
                                            </td>
                                          )}
                                          <td
                                            style={{ color: "black" }}
                                            className="text-center"
                                          >
                                            {Intl.NumberFormat("en-Us").format(
                                              getSubAccountDebit(last),
                                            )}
                                          </td>
                                          <td
                                            style={{ color: "black" }}
                                            className="text-center"
                                          >
                                            {Intl.NumberFormat("en-Us").format(
                                              getSubAccountCredit(last),
                                            )}
                                          </td>
                                          {!oldTrailBalance && (
                                            <td
                                              style={{ color: "black" }}
                                              className="text-center"
                                            >
                                              {formatBalance(last.balance)}
                                            </td>
                                          )}
                                        </tr>
                                      </React.Fragment>
                                    ))}
                                  <tr id="tbl">
                                    <td
                                      style={{
                                        color: "black",
                                        paddingLeft: "30px",
                                      }}
                                      className="text-start"
                                    ></td>
                                    <td
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                      }}
                                      className="text-end pr-10"
                                    >
                                      Control Accounts Total :-
                                    </td>

                                    {!oldTrailBalance && (
                                      <td
                                        style={{
                                          color: "black",
                                          fontWeight: "bold",
                                          borderTop: "2px solid black",
                                          borderBottom: "2px solid black",
                                        }}
                                        className="text-center"
                                      >
                                        {formatBalance(subitem.opening_balance)}
                                      </td>
                                    )}
                                    <td
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                        borderTop: "2px solid black",
                                        borderBottom: "2px solid black",
                                      }}
                                      className="text-center"
                                    >
                                      {Intl.NumberFormat("en-Us").format(
                                        subitem?.account_chart_debit,
                                      )}
                                    </td>

                                    <td
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                        borderTop: "2px solid black",
                                        borderBottom: "2px solid black",
                                      }}
                                      className="text-center"
                                    >
                                      {Intl.NumberFormat("en-Us").format(
                                        subitem?.account_chart_credit,
                                      )}
                                    </td>
                                    {!oldTrailBalance && (
                                      <td
                                        style={{
                                          color: "black",
                                          fontWeight: "bold",
                                          borderTop: "2px solid black",
                                          borderBottom: "2px solid black",
                                        }}
                                        className="text-center"
                                      >
                                        {formatBalance(subitem.balance)}
                                      </td>
                                    )}
                                  </tr>
                                </React.Fragment>
                              ))}
                          </React.Fragment>
                        ))}
                    </React.Fragment>
                  ))}

                  {/* {trialBalanceData.map((base) =>
                                  (base?.base_account_credit > 0 ||
                                    base?.base_account_debit > 0) &&
                                  base?.account_group.length > 0 ? (
                                    <React.Fragment key={base.base_account}>
                                      <tr id="tbl">
                                        <th
                                          colSpan={2}
                                          className="text-center text-color-primary"
                                          style={{ fontSize: "1.1rem" }}
                                        >
                                          {base?.base_account}
                                        </th>
                                        {!oldTrailBalance && (
                                          <th
                                            className="text-center text-color-primary"
                                            style={{ fontSize: "1.1rem" }}
                                          >
                                            {formatBalance(base.opening_balance)}
                                          </th>
                                        )}
                                        <th
                                          className="text-center text-color-primary"
                                          style={{ fontSize: "1.1rem" }}
                                        >
                                          {Intl.NumberFormat("en-Us").format(
                                            base?.base_account_debit,
                                          )}
                                        </th>
                                        <th
                                          className="text-center text-color-primary"
                                          style={{ fontSize: "1.1rem" }}
                                        >
                                          {Intl.NumberFormat("en-Us").format(
                                            base?.base_account_credit,
                                          )}
                                        </th>
                                        {!oldTrailBalance && (
                                          <th
                                            className="text-center text-color-primary"
                                            style={{ fontSize: "1.1rem" }}
                                          >
                                            {formatBalance(base.balance)}
                                          </th>
                                        )}
                                      </tr>
                                      {base.account_group.map((item) =>
                                        (item.account_group_credit > 0 ||
                                          item.account_group_debit > 0) &&
                                        item.account_group.length > 0 ? (
                                          <React.Fragment key={item.account_group_code}>
                                            <tr id="tbl">
                                              <td
                                                style={{
                                                  color: "#fd12b3",
                                                  fontWeight: "bold",
                                                }}
                                                className="text-start pl-10"
                                              >
                                                {item?.account_group_code}
                                              </td>
                                              <td
                                                style={{
                                                  color: "#fd12b3",
                                                  fontWeight: "bold",
                                                }}
                                                className="text-start"
                                              >
                                                {item?.account_group}
                                              </td>
                                              {!oldTrailBalance && (
                                                <td
                                                  style={{
                                                    fontWeight: "bold",
                                                  }}
                                                  className="text-center text-color-primary"
                                                >
                                                  {formatBalance(item.opening_balance)}
                                                </td>
                                              )}
                                              <td
                                                style={{
                                                  fontWeight: "bold",
                                                }}
                                                className="text-center text-color-primary"
                                              >
                                                {Intl.NumberFormat("en-Us").format(
                                                  item?.account_group_debit,
                                                )}
                                              </td>
                                              <td
                                                style={{
                                                  fontWeight: "bold",
                                                }}
                                                className="text-center text-color-primary"
                                              >
                                                {Intl.NumberFormat("en-Us").format(
                                                  item?.account_group_credit,
                                                )}
                                              </td>
                                              {!oldTrailBalance && (
                                                <td
                                                  style={{
                                                    fontWeight: "bold",
                                                  }}
                                                  className="text-center text-color-primary"
                                                >
                                                  {formatBalance(item.balance)}
                                                </td>
                                              )}
                                            </tr>
                                            {item.account_chart.map((subitem) =>
                                              subitem.sub_account.length > 0 ? (
                                                <React.Fragment
                                                  key={subitem.account_chart_code}
                                                >
                                                  <tr id="tbl">
                                                    <td
                                                      style={{
                                                        color: "black",
                                                        paddingLeft: "30px",
                                                        fontWeight: "bold",
                                                      }}
                                                      className="text-center"
                                                    >
                                                      {subitem.account_chart_code}
                                                    </td>
                                                    <td
                                                      style={{
                                                        color: "black",
                                                        paddingLeft: "30px",
                                                        fontWeight: "bold",
                                                      }}
                                                      className="text-start"
                                                    >
                                                      {subitem.account_chart}
                                                    </td>
                                                    {!oldTrailBalance && (
                                                      <td
                                                        style={{ color: "black" }}
                                                        className="text-center"
                                                      ></td>
                                                    )}
                                                    <td
                                                      style={{ color: "black" }}
                                                      className="text-center"
                                                    ></td>
                                                    <td
                                                      style={{ color: "black" }}
                                                      className="text-center"
                                                    ></td>
                                                    {!oldTrailBalance && (
                                                      <td
                                                        style={{ color: "black" }}
                                                        className="text-center"
                                                      ></td>
                                                    )}
                                                  </tr>
                                                  {subitem.sub_account.length > 0
                                                    ? subitem.sub_account.map((last) => (
                                                        <React.Fragment
                                                          key={last.sub_account_code}
                                                        >
                                                          <tr id="tbl">
                                                            <td
                                                              style={{
                                                                color: "black",
                                                                paddingLeft: "60px",
                                                              }}
                                                              className="text-end"
                                                            >
                                                              {last.sub_account_code}
                                                            </td>
                                                            <td
                                                              style={{
                                                                color: "black",
                                                                paddingLeft: "60px",
                                                                cursor: "pointer",
                                                              }}
                                                              className="text-start"
                                                              onClick={() => {
                                                                setSelectedItem(last);
                                                                setViewModal(true);
                                                              }}
                                                            >
                                                              {last.sub_account}
                                                            </td>
                                                            {!oldTrailBalance && (
                                                              <td
                                                                style={{ color: "black" }}
                                                                className="text-center"
                                                              >
                                                                {formatBalance(
                                                                  last.opening_balance,
                                                                )}
                                                              </td>
                                                            )}
                                                            <td
                                                              style={{ color: "black" }}
                                                              className="text-center"
                                                            >
                                                              {Intl.NumberFormat(
                                                                "en-Us",
                                                              ).format(
                                                                !oldTrailBalance
                                                                  ? last.dr
                                                                  : last.debit,
                                                              )}
                                                            </td>
                                                            <td
                                                              style={{ color: "black" }}
                                                              className="text-center"
                                                            >
                                                              {Intl.NumberFormat(
                                                                "en-Us",
                                                              ).format(
                                                                !oldTrailBalance
                                                                  ? last.cr
                                                                  : last.credit,
                                                              )}
                                                            </td>
                                                            {!oldTrailBalance && (
                                                              <td
                                                                style={{ color: "black" }}
                                                                className="text-center"
                                                              >
                                                                {formatBalance(last.balance)}
                                                              </td>
                                                            )}
                                                          </tr>
                                                        </React.Fragment>
                                                      ))
                                                    : null}
                                                  <tr id="tbl">
                                                    <td
                                                      style={{
                                                        color: "black",
                                                        paddingLeft: "30px",
                                                      }}
                                                      className="text-start"
                                                    ></td>
                                                    <td
                                                      style={{
                                                        color: "black",
                                                        fontWeight: "bold",
                                                      }}
                                                      className="text-end pr-10"
                                                    >
                                                      Control Accounts Total :-
                                                    </td>
              
                                                    {!oldTrailBalance && (
                                                      <td
                                                        style={{
                                                          color: "black",
                                                          fontWeight: "bold",
                                                          borderTop: "2px solid black",
                                                          borderBottom: "2px solid black",
                                                        }}
                                                        className="text-center"
                                                      >
                                                        {formatBalance(
                                                          subitem.opening_balance,
                                                        )}
                                                      </td>
                                                    )}
                                                    <td
                                                      style={{
                                                        color: "black",
                                                        fontWeight: "bold",
                                                        borderTop: "2px solid black",
                                                        borderBottom: "2px solid black",
                                                      }}
                                                      className="text-center"
                                                    >
                                                      {Intl.NumberFormat("en-Us").format(
                                                        subitem?.account_chart_debit,
                                                      )}
                                                    </td>
              
                                                    <td
                                                      style={{
                                                        color: "black",
                                                        fontWeight: "bold",
                                                        borderTop: "2px solid black",
                                                        borderBottom: "2px solid black",
                                                      }}
                                                      className="text-center"
                                                    >
                                                      {Intl.NumberFormat("en-Us").format(
                                                        subitem?.account_chart_credit,
                                                      )}
                                                    </td>
                                                    {!oldTrailBalance && (
                                                      <td
                                                        style={{
                                                          color: "black",
                                                          fontWeight: "bold",
                                                          borderTop: "2px solid black",
                                                          borderBottom: "2px solid black",
                                                        }}
                                                        className="text-center"
                                                      >
                                                        {formatBalance(subitem.balance)}
                                                      </td>
                                                    )}
                                                  </tr>
                                                </React.Fragment>
                                              ) : null,
                                            )}
                                          </React.Fragment>
                                        ) : null,
                                      )}
                                    </React.Fragment>
                                  ) : null,
                                )} */}

                  {/* <tr id="tbl">
                    <td
                      style={{ color: "black", paddingLeft: "30px" }}
                      className="text-start"
                    ></td>
                    <td
                      style={{
                        fontSize: "1.3rem",
                        paddingRight: "50px",
                        fontWeight: "bold",
                      }}
                      className="text-end text-color-primary"
                    >
                      {lossDebited != 0
                        ? "Loss Debited :-"
                        : "Profit Credited :-"}
                    </td>
                    {!oldTrailBalance && (
                      <td
                        style={{
                          fontSize: "1.3rem",
                          fontWeight: "bold",
                          borderTop: "2px solid black",
                          borderBottom: "2px solid black",
                        }}
                        className="text-center text-color-primary"
                      ></td>
                    )}
                    <td
                      style={{
                        fontSize: "1.3rem",
                        fontWeight: "bold",
                        borderTop: "2px solid black",
                        borderBottom: "2px solid black",
                      }}
                      className="text-center text-color-primary"
                    >
                      {lossDebited != 0
                        ? Intl.NumberFormat("en-Us").format(lossDebited)
                        : 0}
                    </td>

                    <td
                      style={{
                        fontSize: "1.3rem",
                        fontWeight: "bold",
                        borderTop: "2px solid black",
                        borderBottom: "2px solid black",
                      }}
                      className="text-center text-color-primary"
                    >
                      {profitCredited != 0
                        ? Intl.NumberFormat("en-Us").format(profitCredited)
                        : 0}
                    </td>
                    {!oldTrailBalance && (
                      <td
                        style={{
                          fontSize: "1.3rem",
                          fontWeight: "bold",
                          borderTop: "2px solid black",
                          borderBottom: "2px solid black",
                        }}
                        className="text-center text-color-primary"
                      ></td>
                    )}
                  </tr> */}

                  <tr id="tbl">
                    <td
                      style={{ color: "black", paddingLeft: "30px" }}
                      className="text-start"
                    ></td>
                    <td
                      style={{
                        fontSize: "1.3rem",
                        paddingRight: "50px",
                        fontWeight: "bold",
                      }}
                      className="text-end text-color-primary"
                    >
                      Grand Total :-
                    </td>
                    {!oldTrailBalance && (
                      <td
                        style={{
                          fontSize: "1.3rem",
                          fontWeight: "bold",
                          borderTop: "2px solid black",
                          borderBottom: "2px solid black",
                        }}
                        className="text-center text-color-primary"
                      >
                        {formatBalance(firmBalanceTotals.opening_balance)}
                      </td>
                    )}
                    <td
                      style={{
                        fontSize: "1.3rem",
                        fontWeight: "bold",
                        borderTop: "2px solid black",
                        borderBottom: "2px solid black",
                      }}
                      className="text-center text-color-primary"
                    >
                      {Intl.NumberFormat("en-Us").format(debitSum) || 0}
                    </td>

                    <td
                      style={{
                        fontSize: "1.3rem",
                        fontWeight: "bold",
                        borderTop: "2px solid black",
                        borderBottom: "2px solid black",
                      }}
                      className="text-center text-color-primary"
                    >
                      {Intl.NumberFormat("en-Us").format(creditSum) || 0}
                    </td>
                    {!oldTrailBalance && (
                      <td
                        style={{
                          fontSize: "1.3rem",
                          fontWeight: "bold",
                          borderTop: "2px solid black",
                          borderBottom: "2px solid black",
                        }}
                        className="text-center text-color-primary"
                      >
                        {formatBalance(firmBalanceTotals.balance)}
                      </td>
                    )}
                  </tr>
                </tbody>
              </Table>
            </div>
          ) : null}
        </div>
      </Paper>

      <div
        ref={componentRef}
        id="printSection"
        style={{ visibility: "hidden" }}
        className="tablePrint"
      >
        <div id="tableboot mt-4">
          <div className="d-flex">
            <div className="">
              <img
                style={{ height: 100, width: 110, paddingLeft: "20px" }}
                src={icon}
                alt="logo"
              />
            </div>
            <div className="mx-5" style={{ paddingTop: "10px" }}>
              <h1>{unitName}</h1>
              <h3>
                Firm Wise Report For The Financial Year {sessionName} Till Date{" "}
                {date}
              </h3>
              <h3>Firm Name: {firmName}</h3>
            </div>
          </div>
          <Table responsive>
            <thead>
              <tr id="tbl">
                <th className="text-center" style={{ fontSize: "18px" }}>
                  A/C Code
                </th>
                <th className="text-start" style={{ fontSize: "18px" }}>
                  Account Name
                </th>
                {!oldTrailBalance && (
                  <th className="text-center" style={{ fontSize: "18px" }}>
                    Opening Bal.
                  </th>
                )}
                <th className="text-center" style={{ fontSize: "18px" }}>
                  Debit
                </th>
                <th className="text-center" style={{ fontSize: "18px" }}>
                  Credit
                </th>
                {!oldTrailBalance && (
                  <th className="text-center" style={{ fontSize: "18px" }}>
                    Balance
                  </th>
                )}
              </tr>
            </thead>

            <tbody>
              {firmBalanceData?.filter(hasBaseBalance)?.map((base) => (
                <React.Fragment key={base.base_account}>
                  <tr
                    id="tbl"
                    style={{
                      borderTop: "1px solid black",
                      borderBottom: "1px solid black",
                    }}
                  >
                    <th
                      className="text-center"
                      style={{
                        fontSize: "20px",
                        whiteSpace: "normal",
                        padding: "1px",
                        color: `${config.txtColor}`,
                      }}
                    >
                      {base?.base_account}
                    </th>
                    <th></th>
                    {!oldTrailBalance && (
                      <th
                        className="text-center"
                        style={{
                          fontSize: "18px",
                          whiteSpace: "normal",
                          padding: "1px",
                          color: `${config.txtColor}`,
                        }}
                      >
                        {formatBalance(base.opening_balance)}
                      </th>
                    )}
                    <th
                      className="text-center"
                      style={{
                        fontSize: "18px",
                        whiteSpace: "normal",
                        padding: "1px",
                        color: `${config.txtColor}`,
                      }}
                    >
                      {Intl.NumberFormat("en-Us").format(
                        base?.base_account_debit,
                      )}
                    </th>
                    <th
                      className="text-center"
                      style={{
                        fontSize: "18px",
                        whiteSpace: "normal",
                        padding: "1px",
                        color: `${config.txtColor}`,
                      }}
                    >
                      {Intl.NumberFormat("en-Us").format(
                        base?.base_account_credit,
                      )}
                    </th>
                    {!oldTrailBalance && (
                      <th
                        className="text-center"
                        style={{
                          fontSize: "18px",
                          whiteSpace: "normal",
                          padding: "1px",
                          color: `${config.txtColor}`,
                        }}
                      >
                        {formatBalance(base.balance)}
                      </th>
                    )}
                  </tr>
                  {base.account_group?.filter(hasGroupBalance)?.map((item) => (
                    <React.Fragment key={item.account_group_code}>
                      <tr
                        id="tbl"
                        style={{
                          fontSize: "18px",
                          whiteSpace: "normal",
                          padding: "1px",
                          borderTop: "1px solid black",
                          borderBottom: "1px solid black",
                        }}
                      >
                        <td
                          style={{
                            color: "#fd12b3",
                            fontWeight: "bold",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                          className="text-start pl-10"
                        >
                          {item.account_group_code}
                        </td>
                        <td
                          style={{
                            color: "#fd12b3",
                            fontWeight: "bold",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                          className="text-start"
                        >
                          {item.account_group}
                        </td>
                        {!oldTrailBalance && (
                          <td
                            style={{
                              fontWeight: "bold",
                              whiteSpace: "normal",
                              padding: "1px",
                              color: `${config.txtColor}`,
                              fontSize: "17px",
                            }}
                            className="text-center"
                          >
                            {formatBalance(item.opening_balance)}
                          </td>
                        )}
                        <td
                          style={{
                            fontWeight: "bold",
                            whiteSpace: "normal",
                            padding: "1px",
                            color: `${config.txtColor}`,
                            fontSize: "17px",
                          }}
                          className="text-center"
                        >
                          {Intl.NumberFormat("en-Us").format(
                            item?.account_group_debit,
                          )}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            whiteSpace: "normal",
                            padding: "1px",
                            color: `${config.txtColor}`,
                            fontSize: "17px",
                          }}
                          className="text-center"
                        >
                          {Intl.NumberFormat("en-Us").format(
                            item?.account_group_credit,
                          )}
                        </td>
                        {!oldTrailBalance && (
                          <td
                            style={{
                              fontWeight: "bold",
                              whiteSpace: "normal",
                              padding: "1px",
                              color: `${config.txtColor}`,
                              fontSize: "17px",
                            }}
                            className="text-center"
                          >
                            {formatBalance(item.balance)}
                          </td>
                        )}
                      </tr>
                      {item.account_chart
                        ?.filter(hasChartBalance)
                        ?.map((subitem) => (
                          <React.Fragment key={subitem.account_chart_code}>
                            <tr
                              id="tbl"
                              style={{
                                fontSize: "18px",
                                whiteSpace: "normal",
                                padding: "1px",
                                borderTop: "1px solid black",
                                borderBottom: "1px solid black",
                              }}
                            >
                              <td
                                style={{
                                  color: "black",
                                  paddingLeft: "30px",
                                  fontWeight: "bold",
                                  whiteSpace: "normal",
                                  paddingTop: "1px",
                                  paddingBottom: "1px",
                                }}
                                className="text-center"
                              >
                                {subitem.account_chart_code}
                              </td>
                              <td
                                style={{
                                  color: "black",
                                  paddingLeft: "30px",
                                  fontWeight: "bold",
                                  whiteSpace: "normal",
                                  paddingTop: "1px",
                                  paddingBottom: "1px",
                                }}
                                className="text-start"
                              >
                                {subitem.account_chart}
                              </td>
                              {!oldTrailBalance && (
                                <td
                                  style={{ color: "black" }}
                                  className="text-end"
                                ></td>
                              )}
                              <td
                                style={{ color: "black" }}
                                className="text-end"
                              ></td>
                              <td
                                style={{ color: "black" }}
                                className="text-end"
                              ></td>
                              {!oldTrailBalance && (
                                <td
                                  style={{ color: "black" }}
                                  className="text-end"
                                ></td>
                              )}
                            </tr>
                            {subitem.sub_account
                              ?.filter(hasSubAccountBalance)
                              ?.map((last) => (
                                <React.Fragment key={last.sub_account_code}>
                                  <tr
                                    id="tbl"
                                    style={{
                                      fontSize: "16px",
                                      whiteSpace: "normal",
                                      padding: "1px",
                                    }}
                                  >
                                    <td
                                      style={{
                                        color: "black",
                                        paddingLeft: "60px",
                                        whiteSpace: "normal",
                                        paddingTop: "1px",
                                        paddingBottom: "1px",
                                      }}
                                      className="text-end"
                                    >
                                      {last.sub_account_code}
                                    </td>
                                    <td
                                      style={{
                                        color: "black",
                                        paddingLeft: "60px",
                                        whiteSpace: "normal",
                                        paddingTop: "1px",
                                        paddingBottom: "1px",
                                      }}
                                      className="text-start"
                                    >
                                      {last.sub_account}
                                    </td>
                                    {!oldTrailBalance && (
                                      <td
                                        style={{
                                          color: "black",
                                          whiteSpace: "normal",
                                          paddingTop: "1px",
                                          paddingBottom: "1px",
                                        }}
                                        className="text-center"
                                      >
                                        {formatBalance(last.opening_balance)}
                                      </td>
                                    )}
                                    <td
                                      style={{
                                        color: "black",
                                        whiteSpace: "normal",
                                        paddingTop: "1px",
                                        paddingBottom: "1px",
                                      }}
                                      className="text-center"
                                    >
                                      {Intl.NumberFormat("en-Us").format(
                                        getSubAccountDebit(last),
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        color: "black",
                                        whiteSpace: "normal",
                                        paddingTop: "1px",
                                        paddingBottom: "1px",
                                      }}
                                      className="text-center"
                                    >
                                      {Intl.NumberFormat("en-Us").format(
                                        getSubAccountCredit(last),
                                      )}
                                    </td>
                                    {!oldTrailBalance && (
                                      <td
                                        style={{
                                          color: "black",
                                          whiteSpace: "normal",
                                          paddingTop: "1px",
                                          paddingBottom: "1px",
                                        }}
                                        className="text-center"
                                      >
                                        {formatBalance(last.balance)}
                                      </td>
                                    )}
                                  </tr>
                                </React.Fragment>
                              ))}
                            <tr
                              id="tbl"
                              style={{
                                fontSize: "16px",
                                whiteSpace: "normal",
                                padding: "1px",
                                borderTop: "1px solid black",
                                borderBottom: "1px solid black",
                              }}
                            >
                              <td
                                style={{
                                  color: "black",
                                  paddingLeft: "30px",
                                  whiteSpace: "normal",
                                  paddingTop: "1px",
                                  paddingBottom: "1px",
                                }}
                                className="text-start"
                              ></td>
                              <td
                                style={{
                                  color: "black",
                                  fontWeight: "bold",
                                  whiteSpace: "normal",
                                  paddingTop: "1px",
                                  paddingBottom: "1px",
                                }}
                                className="text-end pr-10"
                              >
                                Control Accounts Total :-
                              </td>
                              {!oldTrailBalance && (
                                <td
                                  style={{
                                    color: "black",
                                    fontWeight: "bold",
                                    borderTop: "2px solid black",
                                    borderBottom: "2px solid black",
                                    whiteSpace: "normal",
                                    paddingTop: "1px",
                                    paddingBottom: "1px",
                                  }}
                                  className="text-center"
                                >
                                  {formatBalance(subitem.opening_balance)}
                                </td>
                              )}
                              <td
                                style={{
                                  color: "black",
                                  fontWeight: "bold",
                                  borderTop: "2px solid black",
                                  borderBottom: "2px solid black",
                                  whiteSpace: "normal",
                                  paddingTop: "1px",
                                  paddingBottom: "1px",
                                }}
                                className="text-center"
                              >
                                {Intl.NumberFormat("en-Us").format(
                                  subitem?.account_chart_debit,
                                )}
                              </td>

                              <td
                                style={{
                                  color: "black",
                                  fontWeight: "bold",
                                  borderTop: "2px solid black",
                                  borderBottom: "2px solid black",
                                  whiteSpace: "normal",
                                  paddingTop: "1px",
                                  paddingBottom: "1px",
                                }}
                                className="text-center"
                              >
                                {Intl.NumberFormat("en-Us").format(
                                  subitem?.account_chart_credit,
                                )}
                              </td>
                              {!oldTrailBalance && (
                                <td
                                  style={{
                                    color: "black",
                                    fontWeight: "bold",
                                    borderTop: "2px solid black",
                                    borderBottom: "2px solid black",
                                    whiteSpace: "normal",
                                    paddingTop: "1px",
                                    paddingBottom: "1px",
                                  }}
                                  className="text-center"
                                >
                                  {formatBalance(subitem.balance)}
                                </td>
                              )}
                            </tr>
                          </React.Fragment>
                        ))}
                    </React.Fragment>
                  ))}
                </React.Fragment>
              ))}

              {/* <tr
                          id="tbl"
                          style={{
                            fontSize: "20px",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                        >
                          <td
                            style={{ color: "black", paddingLeft: "30px" }}
                            className="text-start"
                          ></td>
                          <td
                            style={{
                              fontSize: "1.5rem",
                              paddingRight: "50px",
                              fontWeight: "bold",
                              whiteSpace: "normal",
                              paddingTop: "1px",
                              paddingBottom: "1px",
                              color: `${config.txtColor}`,
                            }}
                            className="text-end"
                          >
                            {lossDebited != 0 ? "Loss Debited :-" : "Profit Credited :-"}
                          </td>
          
                          {!oldTrailBalance && <td></td>}
                          <td
                            style={{
                              fontSize: "1.5rem",
                              fontWeight: "bold",
                              borderTop: "2px solid black",
                              borderBottom: "2px solid black",
                              whiteSpace: "normal",
                              paddingTop: "1px",
                              paddingBottom: "1px",
                              color: `${config.txtColor}`,
                            }}
                            className="text-center"
                          >
                            {lossDebited != 0
                              ? Intl.NumberFormat("en-Us").format(lossDebited)
                              : 0}
                          </td>
          
                          <td
                            style={{
                              fontSize: "1.5rem",
                              fontWeight: "bold",
                              borderTop: "2px solid black",
                              borderBottom: "2px solid black",
                              whiteSpace: "normal",
                              paddingTop: "1px",
                              paddingBottom: "1px",
                              color: `${config.txtColor}`,
                            }}
                            className="text-center"
                          >
                            {profitCredited != 0
                              ? Intl.NumberFormat("en-Us").format(profitCredited)
                              : 0}
                          </td>
                          {!oldTrailBalance && <td></td>}
                        </tr> */}

              <tr
                id="tbl"
                style={{
                  fontSize: "20px",
                  whiteSpace: "normal",
                  padding: "1px",
                }}
              >
                <td
                  style={{ color: "black", paddingLeft: "30px" }}
                  className="text-start"
                ></td>
                <td
                  style={{
                    fontSize: "1.4rem",
                    paddingRight: "50px",
                    fontWeight: "bold",
                    whiteSpace: "normal",
                    paddingTop: "1px",
                    paddingBottom: "1px",
                    color: `${config.txtColor}`,
                  }}
                  className="text-end"
                >
                  Grand Total :-
                </td>

                {!oldTrailBalance && (
                  <td
                    style={{
                      fontSize: "1.4rem",
                      fontWeight: "bold",
                      borderTop: "2px solid black",
                      borderBottom: "2px solid black",
                      whiteSpace: "normal",
                      paddingTop: "1px",
                      paddingBottom: "1px",
                      color: `${config.txtColor}`,
                    }}
                    className="text-center"
                  >
                    {formatBalance(firmBalanceTotals.opening_balance)}
                  </td>
                )}
                <td
                  style={{
                    fontSize: "1.4rem",
                    fontWeight: "bold",
                    borderTop: "2px solid black",
                    borderBottom: "2px solid black",
                    whiteSpace: "normal",
                    paddingTop: "1px",
                    paddingBottom: "1px",
                    color: `${config.txtColor}`,
                  }}
                  className="text-center"
                >
                  {Intl.NumberFormat("en-Us").format(debitSum) || 0}
                </td>

                <td
                  style={{
                    fontSize: "1.4rem",
                    fontWeight: "bold",
                    borderTop: "2px solid black",
                    borderBottom: "2px solid black",
                    whiteSpace: "normal",
                    paddingTop: "1px",
                    paddingBottom: "1px",
                    color: `${config.txtColor}`,
                  }}
                  className="text-center"
                >
                  {Intl.NumberFormat("en-Us").format(creditSum) || 0}
                </td>
                {!oldTrailBalance && (
                  <td
                    style={{
                      fontSize: "1.4rem",
                      fontWeight: "bold",
                      borderTop: "2px solid black",
                      borderBottom: "2px solid black",
                      whiteSpace: "normal",
                      paddingTop: "1px",
                      paddingBottom: "1px",
                      color: `${config.txtColor}`,
                    }}
                    className="text-center"
                  >
                    {formatBalance(firmBalanceTotals.balance)}
                  </td>
                )}
              </tr>
            </tbody>
          </Table>
        </div>
      </div>

      <Table ref={tableRef} style={{ display: "none" }}>
        <thead>
          <tr id="tbl">
            <th className="text-center" style={{ fontSize: "18px" }}>
              A/C Code
            </th>
            <th className="text-start" style={{ fontSize: "18px" }}>
              Account Name
            </th>
            {!oldTrailBalance && (
              <th className="text-center" style={{ fontSize: "18px" }}>
                Opening Bal.
              </th>
            )}
            <th className="text-center" style={{ fontSize: "18px" }}>
              Debit
            </th>
            <th className="text-center" style={{ fontSize: "18px" }}>
              Credit
            </th>
            {!oldTrailBalance && (
              <th className="text-center" style={{ fontSize: "18px" }}>
                Balance
              </th>
            )}
          </tr>
        </thead>

        <tbody>
          {firmBalanceData?.filter(hasBaseBalance)?.map((base) => (
            <React.Fragment key={base.base_account}>
              <tr id="tbl">
                <th
                  className="text-center"
                  style={{
                    fontSize: "20px",
                    whiteSpace: "normal",
                    padding: "1px",
                    color: `${config.txtColor}`,
                  }}
                >
                  {base?.base_account}
                </th>
                <th></th>
                {!oldTrailBalance && (
                  <th
                    className="text-center"
                    style={{
                      fontSize: "18px",
                      whiteSpace: "normal",
                      padding: "1px",
                      color: `${config.txtColor}`,
                    }}
                  >
                    {formatBalance(base.opening_balance)}
                  </th>
                )}
                <th
                  className="text-center"
                  style={{
                    fontSize: "18px",
                    whiteSpace: "normal",
                    padding: "1px",
                    color: `${config.txtColor}`,
                  }}
                >
                  {Intl.NumberFormat("en-Us").format(base?.base_account_debit)}
                </th>
                <th
                  className="text-center"
                  style={{
                    fontSize: "18px",
                    whiteSpace: "normal",
                    padding: "1px",
                    color: `${config.txtColor}`,
                  }}
                >
                  {Intl.NumberFormat("en-Us").format(base?.base_account_credit)}
                </th>
                {!oldTrailBalance && (
                  <th
                    className="text-center"
                    style={{
                      fontSize: "18px",
                      whiteSpace: "normal",
                      padding: "1px",
                      color: `${config.txtColor}`,
                    }}
                  >
                    {formatBalance(base.balance)}
                  </th>
                )}
              </tr>
              {base.account_group?.filter(hasGroupBalance)?.map((item) => (
                <React.Fragment key={item.account_group_code}>
                  <tr
                    id="tbl"
                    style={{
                      fontSize: "18px",
                      whiteSpace: "normal",
                      padding: "1px",
                    }}
                  >
                    <td
                      style={{
                        color: "#fd12b3",
                        fontWeight: "bold",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                      className="text-start pl-10"
                    >
                      {item.account_group_code}
                    </td>
                    <td
                      style={{
                        color: "#fd12b3",
                        fontWeight: "bold",
                        whiteSpace: "normal",
                        padding: "1px",
                      }}
                      className="text-start"
                    >
                      {item.account_group}
                    </td>
                    {!oldTrailBalance && (
                      <td
                        style={{
                          fontWeight: "bold",
                          whiteSpace: "normal",
                          padding: "1px",
                          color: `${config.txtColor}`,
                          fontSize: "17px",
                        }}
                        className="text-center"
                      >
                        {formatBalance(item.opening_balance)}
                      </td>
                    )}
                    <td
                      style={{
                        fontWeight: "bold",
                        whiteSpace: "normal",
                        padding: "1px",
                        color: `${config.txtColor}`,
                        fontSize: "17px",
                      }}
                      className="text-center"
                    >
                      {Intl.NumberFormat("en-Us").format(
                        item?.account_group_debit,
                      )}
                    </td>
                    <td
                      style={{
                        fontWeight: "bold",
                        whiteSpace: "normal",
                        padding: "1px",
                        color: `${config.txtColor}`,
                        fontSize: "17px",
                      }}
                      className="text-center"
                    >
                      {Intl.NumberFormat("en-Us").format(
                        item?.account_group_credit,
                      )}
                    </td>
                    {!oldTrailBalance && (
                      <td
                        style={{
                          fontWeight: "bold",
                          whiteSpace: "normal",
                          padding: "1px",
                          color: `${config.txtColor}`,
                          fontSize: "17px",
                        }}
                        className="text-center"
                      >
                        {formatBalance(item.balance)}
                      </td>
                    )}
                  </tr>
                  {item.account_chart
                    ?.filter(hasChartBalance)
                    ?.map((subitem) => (
                      <React.Fragment key={subitem.account_chart_code}>
                        <tr
                          id="tbl"
                          style={{
                            fontSize: "18px",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                        >
                          <td
                            style={{
                              color: "black",
                              paddingLeft: "30px",
                              fontWeight: "bold",
                              whiteSpace: "normal",
                              paddingTop: "1px",
                              paddingBottom: "1px",
                            }}
                            className="text-center"
                          >
                            {subitem.account_chart_code}
                          </td>
                          <td
                            style={{
                              color: "black",
                              paddingLeft: "30px",
                              fontWeight: "bold",
                              whiteSpace: "normal",
                              paddingTop: "1px",
                              paddingBottom: "1px",
                            }}
                            className="text-start"
                          >
                            {subitem.account_chart}
                          </td>
                          {!oldTrailBalance && (
                            <td
                              style={{ color: "black" }}
                              className="text-end"
                            ></td>
                          )}
                          <td
                            style={{ color: "black" }}
                            className="text-end"
                          ></td>
                          <td
                            style={{ color: "black" }}
                            className="text-end"
                          ></td>
                          {!oldTrailBalance && (
                            <td
                              style={{ color: "black" }}
                              className="text-end"
                            ></td>
                          )}
                        </tr>
                        {subitem.sub_account
                          ?.filter(hasSubAccountBalance)
                          ?.map((last) => (
                            <React.Fragment key={last.sub_account_code}>
                              <tr
                                id="tbl"
                                style={{
                                  fontSize: "16px",
                                  whiteSpace: "normal",
                                  padding: "1px",
                                }}
                              >
                                <td
                                  style={{
                                    color: "black",
                                    paddingLeft: "60px",
                                    whiteSpace: "normal",
                                    paddingTop: "1px",
                                    paddingBottom: "1px",
                                  }}
                                  className="text-end"
                                >
                                  {last.sub_account_code}
                                </td>
                                <td
                                  style={{
                                    color: "black",
                                    paddingLeft: "60px",
                                    whiteSpace: "normal",
                                    paddingTop: "1px",
                                    paddingBottom: "1px",
                                  }}
                                  className="text-start"
                                >
                                  {last.sub_account}
                                </td>
                                {!oldTrailBalance && (
                                  <td
                                    style={{
                                      color: "black",
                                      whiteSpace: "normal",
                                      paddingTop: "1px",
                                      paddingBottom: "1px",
                                    }}
                                    className="text-center"
                                  >
                                    {formatBalance(last.opening_balance)}
                                  </td>
                                )}
                                <td
                                  style={{
                                    color: "black",
                                    whiteSpace: "normal",
                                    paddingTop: "1px",
                                    paddingBottom: "1px",
                                  }}
                                  className="text-center"
                                >
                                  {Intl.NumberFormat("en-Us").format(
                                    getSubAccountDebit(last),
                                  )}
                                </td>
                                <td
                                  style={{
                                    color: "black",
                                    whiteSpace: "normal",
                                    paddingTop: "1px",
                                    paddingBottom: "1px",
                                  }}
                                  className="text-center"
                                >
                                  {Intl.NumberFormat("en-Us").format(
                                    getSubAccountCredit(last),
                                  )}
                                </td>
                                {!oldTrailBalance && (
                                  <td
                                    style={{
                                      color: "black",
                                      whiteSpace: "normal",
                                      paddingTop: "1px",
                                      paddingBottom: "1px",
                                    }}
                                    className="text-center"
                                  >
                                    {formatBalance(last.balance)}
                                  </td>
                                )}
                              </tr>
                            </React.Fragment>
                          ))}
                        <tr
                          id="tbl"
                          style={{
                            fontSize: "16px",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                        >
                          <td
                            style={{
                              color: "black",
                              paddingLeft: "30px",
                              whiteSpace: "normal",
                              paddingTop: "1px",
                              paddingBottom: "1px",
                            }}
                            className="text-start"
                          ></td>
                          <td
                            style={{
                              color: "black",
                              fontWeight: "bold",
                              whiteSpace: "normal",
                              paddingTop: "1px",
                              paddingBottom: "1px",
                            }}
                            className="text-end pr-10"
                          >
                            Control Accounts Total :-
                          </td>
                          {!oldTrailBalance && (
                            <td
                              style={{
                                color: "black",
                                fontWeight: "bold",
                                borderTop: "2px solid black",
                                borderBottom: "2px solid black",
                                whiteSpace: "normal",
                                paddingTop: "1px",
                                paddingBottom: "1px",
                              }}
                              className="text-center"
                            >
                              {formatBalance(subitem.opening_balance)}
                            </td>
                          )}
                          <td
                            style={{
                              color: "black",
                              fontWeight: "bold",
                              borderTop: "2px solid black",
                              borderBottom: "2px solid black",
                              whiteSpace: "normal",
                              paddingTop: "1px",
                              paddingBottom: "1px",
                            }}
                            className="text-center"
                          >
                            {Intl.NumberFormat("en-Us").format(
                              subitem?.account_chart_debit,
                            )}
                          </td>

                          <td
                            style={{
                              color: "black",
                              fontWeight: "bold",
                              borderTop: "2px solid black",
                              borderBottom: "2px solid black",
                              whiteSpace: "normal",
                              paddingTop: "1px",
                              paddingBottom: "1px",
                            }}
                            className="text-center"
                          >
                            {Intl.NumberFormat("en-Us").format(
                              subitem?.account_chart_credit,
                            )}
                          </td>
                          {!oldTrailBalance && (
                            <td
                              style={{
                                color: "black",
                                fontWeight: "bold",
                                borderTop: "2px solid black",
                                borderBottom: "2px solid black",
                                whiteSpace: "normal",
                                paddingTop: "1px",
                                paddingBottom: "1px",
                              }}
                              className="text-center"
                            >
                              {formatBalance(subitem.balance)}
                            </td>
                          )}
                        </tr>
                      </React.Fragment>
                    ))}
                </React.Fragment>
              ))}
            </React.Fragment>
          ))}

          {/* <tr
                          id="tbl"
                          style={{
                            fontSize: "20px",
                            whiteSpace: "normal",
                            padding: "1px",
                          }}
                        >
                          <td
                            style={{ color: "black", paddingLeft: "30px" }}
                            className="text-start"
                          ></td>
                          <td
                            style={{
                              fontSize: "1.5rem",
                              paddingRight: "50px",
                              fontWeight: "bold",
                              whiteSpace: "normal",
                              paddingTop: "1px",
                              paddingBottom: "1px",
                              color: `${config.txtColor}`,
                            }}
                            className="text-end"
                          >
                            {lossDebited != 0 ? "Loss Debited :-" : "Profit Credited :-"}
                          </td>
          
                          {!oldTrailBalance && <td></td>}
                          <td
                            style={{
                              fontSize: "1.5rem",
                              fontWeight: "bold",
                              borderTop: "2px solid black",
                              borderBottom: "2px solid black",
                              whiteSpace: "normal",
                              paddingTop: "1px",
                              paddingBottom: "1px",
                              color: `${config.txtColor}`,
                            }}
                            className="text-center"
                          >
                            {lossDebited != 0
                              ? Intl.NumberFormat("en-Us").format(lossDebited)
                              : 0}
                          </td>
          
                          <td
                            style={{
                              fontSize: "1.5rem",
                              fontWeight: "bold",
                              borderTop: "2px solid black",
                              borderBottom: "2px solid black",
                              whiteSpace: "normal",
                              paddingTop: "1px",
                              paddingBottom: "1px",
                              color: `${config.txtColor}`,
                            }}
                            className="text-center"
                          >
                            {profitCredited != 0
                              ? Intl.NumberFormat("en-Us").format(profitCredited)
                              : 0}
                          </td>
                          {!oldTrailBalance && <td></td>}
                        </tr> */}

          <tr
            id="tbl"
            style={{
              fontSize: "20px",
              whiteSpace: "normal",
              padding: "1px",
            }}
          >
            <td
              style={{ color: "black", paddingLeft: "30px" }}
              className="text-start"
            ></td>
            <td
              style={{
                fontSize: "1.4rem",
                paddingRight: "50px",
                fontWeight: "bold",
                whiteSpace: "normal",
                paddingTop: "1px",
                paddingBottom: "1px",
                color: `${config.txtColor}`,
              }}
              className="text-end"
            >
              Grand Total :-
            </td>

            {!oldTrailBalance && (
              <td
                style={{
                  fontSize: "1.4rem",
                  fontWeight: "bold",
                  borderTop: "2px solid black",
                  borderBottom: "2px solid black",
                  whiteSpace: "normal",
                  paddingTop: "1px",
                  paddingBottom: "1px",
                  color: `${config.txtColor}`,
                }}
                className="text-center"
              >
                {formatBalance(firmBalanceTotals.opening_balance)}
              </td>
            )}
            <td
              style={{
                fontSize: "1.4rem",
                fontWeight: "bold",
                borderTop: "2px solid black",
                borderBottom: "2px solid black",
                whiteSpace: "normal",
                paddingTop: "1px",
                paddingBottom: "1px",
                color: `${config.txtColor}`,
              }}
              className="text-center"
            >
              {Intl.NumberFormat("en-Us").format(debitSum) || 0}
            </td>

            <td
              style={{
                fontSize: "1.4rem",
                fontWeight: "bold",
                borderTop: "2px solid black",
                borderBottom: "2px solid black",
                whiteSpace: "normal",
                paddingTop: "1px",
                paddingBottom: "1px",
                color: `${config.txtColor}`,
              }}
              className="text-center"
            >
              {Intl.NumberFormat("en-Us").format(creditSum) || 0}
            </td>
            {!oldTrailBalance && (
              <td
                style={{
                  fontSize: "1.4rem",
                  fontWeight: "bold",
                  borderTop: "2px solid black",
                  borderBottom: "2px solid black",
                  whiteSpace: "normal",
                  paddingTop: "1px",
                  paddingBottom: "1px",
                  color: `${config.txtColor}`,
                }}
                className="text-center"
              >
                {formatBalance(firmBalanceTotals.balance)}
              </td>
            )}
          </tr>
        </tbody>
      </Table>

      <Modal
        show={viewModal}
        centered
        size="xl"
        onHide={() => setViewModal(false)}
      >
        <Modal.Header className="modal_header_style" closeButton>
          <Modal.Title
            className="Modal_Heading_font"
            id="contained-modal-title-vcenter"
          >
            {selectedItem.sub_account}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ height: "550px", overflowX: "scroll" }}>
            <Table responsive>
              <thead>
                <tr id="tbl">
                  <th className="text-start">Date</th>
                  <th className="text-start">Description</th>
                  <th className="text-end">Debit</th>
                  <th className="text-end">Credit</th>
                  {!oldTrailBalance && <th className="text-end">Balance</th>}
                </tr>
              </thead>

              <tbody>
                {getLedgersWithBalance(selectedItem?.general_ledgers)?.map(
                  (item, index) => (
                    <tr id="tbl" key={item.id || index}>
                      <td style={{ color: "black" }} className="text-start">
                        {item.transaction_at}
                      </td>
                      <td style={{ color: "black" }} className="text-start">
                        {item.remarks}
                      </td>

                      <td
                        style={{
                          color: `${config.txtColor}`,
                          fontWeight: "bold",
                        }}
                        className="text-end"
                      >
                        {Intl.NumberFormat("en-Us").format(item.debit)}
                      </td>

                      <td
                        style={{
                          color: `${config.txtColor}`,
                          fontWeight: "bold",
                        }}
                        className="text-end"
                      >
                        {Intl.NumberFormat("en-Us").format(item.credit)}
                      </td>
                      {!oldTrailBalance && (
                        <td
                          style={{
                            color: `${config.txtColor}`,
                            fontWeight: "bold",
                          }}
                          className="text-end"
                        >
                          {formatBalance(item.balance)}
                        </td>
                      )}
                    </tr>
                  ),
                )}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-danger"
            onClick={() => setViewModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FirmWiseReport;
